/**
 * Hizmet durumu — abonelik sona erdiğinde ekranın fiyatları GİZLEMESİ için.
 *
 * NEDEN VAR (2026-09-14):
 * Abonelik kesilince gateway artık tick yaymıyor. Ama bu tek başına ekranı
 * durdurmuyor: `tickStore` son fiyatları bellekte tutar (reconnect'te fiyat
 * kaybolmasın diye — bilinçli karar) ve collector'lar canlı olduğu için ekran
 * durumu `calm`'a düşer; `calm`'da uyarı bandı bilerek gösterilmez. Yani ekran
 * hiçbir uyarı vermeden DONMUŞ eski fiyatı göstermeye devam ederdi.
 *
 * Vitrindeki bir ekranda bu, karartmaktan daha kötüdür: dükkâna gelen müşteri
 * bayat altın fiyatını canlı sanıp işlem yapabilir. Bu yüzden gateway `service_status`
 * event'i gönderir ve ekran fiyatları TAMAMEN örter.
 */

export interface ServiceState {
    suspended: boolean;
}

const listeners = new Set<() => void>();

export const serviceState: ServiceState = {
    suspended: false,
};

export function setServiceSuspended(suspended: boolean): void {
    if (serviceState.suspended === suspended) return;
    serviceState.suspended = suspended;
    for (const fn of listeners) fn();
}

export function onServiceStateChange(fn: () => void): () => void {
    listeners.add(fn);
    return () => listeners.delete(fn);
}
